import { useRef, useState, useEffect } from "react";
import { BsPlus } from "react-icons/bs";
import styles from "./todo.module.css";
import { connection } from "utils/apiConnection.ts";
import toast from "react-hot-toast";
const TodoForm = ({ id, setUpdater, setIsLoading }) => {
  const [address, setAddress] = useState({
    address: "",
    title: "",
    user_id: id,
    mobile: ""
  });
  // const [value2, setValue2] = useState("");
  const inputRef = useRef(null);
  const [validate, setValidate] = useState({
    address: false,
    mobile: false,
    validMobile: false
  });
  useEffect(() => {
    inputRef.current.focus();
  }, []);
  const changeHandler = (names, values) => {
    setAddress(prev => {
      return { ...prev, [names]: values };
    });
  };

  const validation = () => {
    let validate = true;
    const pattern = /^09\d{9}$/;
    if (address.address == "") {
      setValidate(prev => {
        return { ...prev, address: true };
      });
      validate = false;
    } else if (address.address != "") {
      setValidate(prev => {
        return { ...prev, address: false };
      });
    }
    if (!pattern.test(address.mobile)) {
      setValidate(prev => {
        return { ...prev, mobile: true };
      });
      validate = false;
    } else if (pattern.test(address.mobile)) {
      setValidate(prev => {
        return { ...prev, mobile: false };
      });
    }

    console.log("patter", pattern.test(address.mobile));
    return validate;
  };

  const addAddress = () => {
    setIsLoading(true);
    connection("api/Insert_usersAddress", address).then(data => {
      if (data.status == true) {
        toast.success("آدرس جدید با موفقیت ثبت شد.");
        setUpdater(prev => !prev);
        setAddress({
          address: "",
          title: "",
          user_id: id,
          mobile: ""
        });
        setIsLoading(false);
      } else {
        toast.error("متاسفانه مشکلی در ثبت آدرس به وجود آمده است.");
        setIsLoading(false);
      }
    });
  };

  return (
    <div className="my-4 ">
      <div
        className="accordion accordion-flush shadow round"
        id="accordionAddress"
      >
        <div className="accordion-item">
          <h2 className="accordion-header" id="flush-address">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-address"
              aria-expanded="false"
              aria-controls="collapse-address"
            >
              افزودن آدرس جدید
            </button>
          </h2>
          <div
            id="collapse-address"
            className="accordion-collapse collapse"
            aria-labelledby="flush-address"
            data-bs-parent="#accordionAddress"
          >
            <div className="accordion-body">
              <form
                //  onSubmit={submitHandler}
                className={styles.felan}
              >
                <div className={styles.boxadd}>
                  <div className={`${styles.width1}`}>
                    <div class="form-floating mb-3 mx-1">
                      <input
                        onChange={e => {
                          changeHandler("title", e.target.value);
                        }}
                        value={address.title}
                        ref={inputRef}
                        type="text"
                        class="form-control"
                        id="floatingInput"
                        placeholder="name@example.com"
                      />
                      <label for="floatingInput">عنوان آدرس :</label>
                    </div>
                  </div>
                  <div className={`${styles.width1}`}>
                    {" "}
                    <div class="form-floating mb-3 mx-1" dir="rtl">
                      <input
                        dir="rtl"
                        onChange={e => {
                          changeHandler("mobile", e.target.value);
                        }}
                        // onChange={changeHandler2}
                        value={address.mobile}
                        type="number"
                        class="form-control"
                        id="floatingInput"
                        placeholder="name@example.com"
                      />
                      <label for="floatingInput">
                        شماره تماس تحویل گیرنده :
                      </label>
                    </div>
                    <p
                      className={`${styles.validateText} ms-2 ${
                        validate.mobile == true ? "d-block" : "d-none"
                      }`}
                    >
                      شماره تماس وارد شده صحیح نیست.
                    </p>
                  </div>
                  <div className={`${styles.width2}`}>
                    <div class="form-floating mb-3 mx-1">
                      <textarea
                        onChange={e => {
                          changeHandler("address", e.target.value);
                        }}
                        value={address.address}
                        ref={inputRef}
                        type="text"
                        class="form-control"
                        id="floatingInput"
                        placeholder="name@example.com"
                      />
                      <label for="floatingInput">آدرس دقیق :</label>
                    </div>
                    <p
                      className={`${styles.validateText} ms-2 ${
                        validate.address == true ? "d-block" : "d-none"
                      }`}
                    >
                      لطفا آدرس را وارد کنید.
                    </p>
                  </div>
                </div>

                <button
                  type="button"
                  className={`shadow ${styles.ntnn}`}
                  onClick={() => {
                    if (validation()) {
                      addAddress();
                    }
                  }}
                >
                  <bdi>
                    <BsPlus />
                  </bdi>
                  <bdi>افزودن آدرس جدید</bdi>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodoForm;
